import { render, staticRenderFns } from "./CommentUserCell.vue?vue&type=template&id=6ba092dd&scoped=true&"
import script from "./CommentUserCell.vue?vue&type=script&lang=ts&"
export * from "./CommentUserCell.vue?vue&type=script&lang=ts&"
import style0 from "./CommentUserCell.vue?vue&type=style&index=0&id=6ba092dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba092dd",
  null
  
)

export default component.exports